<template>
  <div>

    <!-- PHASE 1: Secret kod kiritish -->
    <div v-if="!create" class="verify-page">
      <div class="verify-card">
        <div class="verify-icon-wrap">
          <b-icon icon="shield-lock-fill" font-scale="2.5" style="color:#a142f4"></b-icon>
        </div>
        <h2 class="verify-title">{{ $t("Yangi filial qo'shish") }}</h2>
        <p class="verify-sub">{{ $t("Davom etish uchun secret kodni kiriting") }}</p>

        <div class="verify-field">
          <label>{{ $t("Secret kod") }}</label>
          <input
            ref="focused"
            v-model="code"
            type="text"
            class="verify-input"
            :placeholder="$t('Kodni kiriting...')"
            @keyup.enter="Send()"
          />
        </div>

        <button class="verify-btn" @click="Send()">
          <b-icon icon="arrow-right-circle-fill"></b-icon>
          {{ $t("Davom etish") }}
        </button>

        <router-link :to="{ path: '/malumot/sklad/index' }" class="back-link">
          <b-icon icon="arrow-left"></b-icon> {{ $t("Ortga qaytish") }}
        </router-link>
      </div>
    </div>

    <!-- PHASE 2: Filial formasi -->
    <sklad-form :datas="dataall" v-if="create"></sklad-form>

    <!-- Saqlanmagan o'zgarishlar modali -->
    <b-modal id="modal-close" centered hide-footer no-close-on-backdrop>
      <div class="text-center p-3">
        <h5 class="mb-4">{{ $t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?') }}</h5>
        <div class="d-flex justify-content-center" style="gap:10px">
          <button class="btn btn-success" @click="$root.$refs.sklad.Savedokument()">{{ $t('Ha') }}</button>
          <button class="btn btn-danger" @click="Home()">{{ $t("Yo'q") }}</button>
          <button class="btn btn-secondary" @click="$bvModal.hide('modal-close')">{{ $t('Bekor qilish') }}</button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { SkladForm } from "@/pages";
export default {
  components: { SkladForm },
  data() {
    return {
      create: false,
      code: '',
      dataurl: '',
      dataall: {
        secret_code: "",
        sms_code: "",
        name: "",
        phone_number: "+998",
        address: "",
        IpServerMobile: "",
        check_word: "",
        update_password: ""
      }
    };
  },
  watch: {
    dataall: {
      deep: true,
      handler() {
        this.$store.state.saved += 1;
      }
    }
  },
  mounted() {
    this.$refs.focused.focus();
    axios.get("http://bdm.uz/server/url").then(res => {
      this.dataurl = res.data;
    });
    axios.get("api/v1/registration/get-ip-address").then(res => {
      if (res.data.Ethernet) {
        this.dataall.ipservermobile = res.data.Ethernet[0];
      } else if (res.data['Wi-Fi']) {
        this.dataall.ipservermobile = res.data['Wi-Fi'][0];
      }
    });
  },
  methods: {
    Home() {
      this.$store.state.saved = null;
      this.$bvModal.hide('modal-close');
      this.$router.push({ name: "Склад" });
    },
    Send() {
      const { username, password, url } = this.dataurl;
      const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64');
      axios.get(`${url}/getLoadSms?secret_code=${this.code}`, {
        headers: { 'Authorization': `Basic ${token}` }
      }).then(res => {
        if (res.data.error === false) {
          this.create = true;
          this.dataall.secret_code = this.code;
        } else {
          this.$store.state.errors = res.data.message;
        }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.create) {
      if (this.$store.state.saved < 2) {
        this.$store.state.saved = null;
        next();
      } else {
        this.$bvModal.show("modal-close");
      }
    } else {
      next();
    }
  }
};
</script>

<style scoped>
.verify-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f8fafc;
}
.verify-card {
  background: white;
  border-radius: 24px;
  padding: 48px 40px;
  box-shadow: 0 20px 60px rgba(161, 66, 244, 0.1);
  border: 1px solid #f1f5f9;
  width: 100%;
  max-width: 420px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.verify-icon-wrap {
  width: 72px;
  height: 72px;
  background: rgba(161, 66, 244, 0.1);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.verify-title {
  color: #1e293b;
  font-weight: 800;
  font-size: 22px;
  margin: 0;
}
.verify-sub {
  color: #94a3b8;
  font-size: 14px;
  margin: 0;
}
.verify-field {
  width: 100%;
  text-align: left;
}
.verify-field label {
  font-weight: 600;
  color: #64748b;
  font-size: 13px;
  margin-bottom: 6px;
  display: block;
}
.verify-input {
  width: 100%;
  height: 50px;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  padding: 0 18px;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.verify-input:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}
.verify-btn {
  width: 100%;
  height: 52px;
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  border-radius: 14px;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 6px 20px rgba(161, 66, 244, 0.35);
}
.back-link {
  color: #94a3b8;
  font-size: 14px;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;
}
.back-link:hover {
  color: #a142f4;
  text-decoration: none;
}
</style>
